
import React, { Fragment, useContext, useState } from 'react'
import classnames from 'classnames'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'reactstrap'

import { Slider } from '../Hamburger'
import { useThemeContext, setEnableMobileMenu, setEnableMobileMenuSmall } from '../../contexts/ThemeProvider'

const ApplicationMobileMenu = () =>
{
	const [controller, dispatch] = useThemeContext()
	const { enableMobileMenu, enableMobileMenuSmall } = controller
	const [active, setActive] = useState(false)
	const [activeSecondaryMenuMobile, setActiveSecondaryMenuMobile] = useState(false)
	
	const toggleMobileSidebar = () =>
	{
		setEnableMobileMenu(dispatch, !enableMobileMenu)
	}
	
	const toggleMobileSmall = () =>
	{
		setEnableMobileMenuSmall(dispatch, !enableMobileMenuSmall)
	}
	
	return (
		<Fragment>
			<div className="app-header__mobile-menu">
				<div onClick={ toggleMobileSidebar }>
					<Slider
						width={26}
						lineHeight={2}
						lineSpacing={5}
						color="#6c757d"
						active={ active }
						onClick={ () => setActive(!active) }
					/>
				</div>
			</div>
			<div className="app-header__menu">
				<span onClick={ toggleMobileSmall }>
					<Button
						size="sm"
						className={ classnames("btn-icon btn-icon-only", { active: activeSecondaryMenuMobile, })}
						color="primary"
						onClick={ () => setActiveSecondaryMenuMobile(!activeSecondaryMenuMobile) }
					>
						<div className="btn-icon-wrapper">
							<FontAwesomeIcon icon={ faEllipsisV } />
						</div>
					</Button>
				</span>
			</div>
		</Fragment>
	)
}

export default ApplicationMobileMenu
